import { createSlice } from "@reduxjs/toolkit";

const initialState = {
	pageTitle: "",
	loading: false,
};

export const AppSlice = createSlice({
	name: "app",
	initialState,
	companyInsuranceInfo: null,
	reducers: {
		setPageTitle: (state, action) => {
			state.pageTitle = action.payload;
		},
		setLoadingState: (state, action) => {
			state.loading = action.payload;
		},
		saveCompanyInsuranceInfo: (state, action) => {
			state.companyInsuranceInfo = action.payload;
		},
	},
});

// Action creators are generated for each case reducer function
export const { setPageTitle, setLoadingState, saveCompanyInsuranceInfo } = AppSlice.actions;

export default AppSlice.reducer;
